import {
  DebtorSearchResult,
} from '@/app/shared/contexts/DebtorAccountContext.types';
import { oktaPost } from '../oktaRequestWrapper';
import { ApiRoutes } from '../apiRoutes';

export const postDebtorSearch = async (
  searchTerm: string,
  size: number = 10,
): Promise<DebtorSearchResult[]> => {
  const request = {
    searchTerm: searchTerm,
    size: size,
    searchableFields: ['name', 'dbaName', 'mc'],
  };

  const response = await oktaPost<DebtorSearchResult[]>(
    ApiRoutes.DebtorSearch,
    request,
    {
      headers: {
        'api-version': '3.0',
      },
    },
  );

  return response.data ?? [];
};